module.exports = __webpack_public_path__ + "static/media/logo.2f9f1b8f.svg";